import React, { useState } from "react";
import Service from '../../../service/Service';

const service = new Service();

export default function DisclaimerPopup({eleRef}) {
    
    const [activeIndex, setActiveIndex] = useState(null);

    const handleCancel= ()=>{
        eleRef.closeDisclaimer();
    }
    const handlePdfClick = (e) => {

        if(eleRef.state.isApp){
            e.preventDefault();

                const deepjson = {
                    appurl: [
                        {
                            pagetype: "viewpdf",
                            isFromShopping: 0,
                            fileName: "1791788880832",
                            hideDownload: 1,
                            url: "https://acvip.org/files/Table%20I-IAP%20Immunization%20Schedule%202016-Final.pdf"
                        }
                    ]
                };
                service.jsontracker(JSON.stringify(deepjson));
        }
    };

    const handleWhoStandardsUrl = (e)=> {

        if(eleRef.state.isApp){
            e.preventDefault();

            let deepjson = {
                appurl: [
                    {
                        "pagetype": "inappbrowser",
                        "url": "https://www.who.int/tools/child-growth-standards"                   
                    }
                ]
            }
            service.jsontracker(JSON.stringify(deepjson));
        }
    };


    return (

        <div className="showDisc-overlay" style={{display: "none"}}>
            <div className="showDiscmodal">

                {/* Header */}
                <div className="faq_title">
                    <button type="button" className="disc_back_btn" onClick={handleCancel} aria-label="Close disclaimer">
                        <img src="https://cdn.cdnparenting.com/brainbees/community/vaccination/left_arrow.png" alt="back"/>
                    </button>

                    <span>Disclaimer</span>
                </div>

                {/* Content */}
                <div className="disc_content">

                    <p>
                        Information used for Vaccination Tracker is based on the latest
                        vaccination schedule provided by the
                        <strong>
                            {" "}IAP Advisory Committee on Vaccines & Immunization Practices.
                        </strong>
                        {" "}This schedule provides generally recommended dates based on your
                        <strong> child's birth date.</strong>
                        {" "}Your child's vaccination history, medical history, and health status
                        can have an effect on these dates. Kindly get in touch with your
                        concerned pediatrician before acting on the same. This is not an
                        official vaccination record.
                    </p>

                    <p>
                        For Growth Tracker, we use the latest child growth standards
                        provided by the World Health Organization (WHO). It describes the
                        optimal growth for healthy, breastfed children.
                    </p>

                    <p>
                        Growth Tracker is an effective indicator to monitor your child's
                        growth over time, but it cannot be used to diagnose a problem.
                        Please consult your paediatrician before taking any action or
                        making any modifications to feeding, sleeping habits, etc.
                    </p>

                    <div className="disc_divider"></div>

                    <div className="reference_sec">
                        <h4>References</h4>

                        <div className="reference_item">
                            <strong>IAP Immunization Timetable 2016</strong>

                            {/* <a href="https://acvip.org/files/Table%20I-IAP%20Immunization%20Schedule%202016-Final.pdf" rel="noreferrer" >
                                IAP Immunization Schedule 2016
                            </a> */}
                            <a href="https://acvip.org/files/Table%20I-IAP%20Immunization%20Schedule%202016-Final.pdf" rel="noreferrer"
                                onClick={handlePdfClick}
                            >
                                IAP Immunization Schedule 2016
                            </a>
                        </div>

                        <div className="reference_item">
                            <strong>WHO Growth Standard Tables</strong>

                            <a href="https://www.who.int/tools/child-growth-standards"  onClick={handleWhoStandardsUrl} rel="noreferrer">
                                WHO Child Growth Standards
                            </a>
                        </div>
                    </div>

                    <div className="disc_divider"></div>

                    <p className="due_note">
                        * Refers to <strong>Due</strong> on the date mentioned against the
                        respective vaccine on the Vaccination Tracker for your child.
                    </p>

                </div>
            </div>
        </div>
    );
};

